import InventoryListingBody from './InventoryListingBody';
export default InventoryListingBody;